import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Route, Routes } from "react-router-dom";

import App from './App';
import { UI } from './components/UI';
import { Console } from './components/Console';
import { Disabled } from './components/Disabled';
import { ConfigProvider } from 'antd';
import { AuthenticationProvider } from './provider/Auth';
import { WSProvider } from './provider/WS';
import { MetaHumanProvider }  from './components/MetaHumanComponent';
import { SpeechToTextProvider } from './components/SpeechToTextComponent';
const root = ReactDOM.createRoot(document.getElementById('root'));



root.render(
  <ConfigProvider direction="ltr">

    <AuthenticationProvider>
      <WSProvider>
        <MetaHumanProvider>
        <SpeechToTextProvider>
          <BrowserRouter>
            <Routes>
              <Route exact path="/" element={<App />}></Route>
              <Route exact path="/ui" element={<UI />}></Route>
              <Route exact path="/disabled" element={<Disabled />}></Route>
              <Route exact path="/console" element={<Console />}></Route>
            </Routes>
          </BrowserRouter>
          </SpeechToTextProvider>
        </MetaHumanProvider>
      </WSProvider>
    </AuthenticationProvider>
  </ConfigProvider>
);

